module.exports = __webpack_public_path__ + "img/member-gift.1834279a.svg";